import { ILiteRouterApiResponse } from "models/ILiteRouterApiResponse";
import { ICountryAssetLite } from "models/Assets/ICountryAsset";
import { ISeoCache } from "../types/types";

export default class NeighbourhoodDescription {
  declare id: number;
  declare description_ar: string;
  declare description_en: string;
}

export const getNeighbourhoodDescriptionByParams = (
  seoCache: ISeoCache,
  routerApiResponse: ILiteRouterApiResponse,
  country: ICountryAssetLite
): NeighbourhoodDescription => {
  let categoryId = routerApiResponse?.categoryId ?? null;
  let subcategoryId = routerApiResponse?.subCategoryId ?? null;
  let cityId = routerApiResponse?.cityId ?? null;
  let neighborhoodId = routerApiResponse?.neighborhoodId ?? null;

  if (!cityId || !neighborhoodId) return;

  return seoCache.getNHoodDescriptionRecord(
    country.id,
    cityId,
    neighborhoodId,
    categoryId,
    subcategoryId
  );
};
